
import { ThumbsDown, ThumbsUp, Minus } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface MessageStatusProps {
  refundApproved?: boolean;
  sentiment?: string;
}

const MessageStatus = ({ refundApproved, sentiment }: MessageStatusProps) => {
  if (refundApproved === undefined && !sentiment) return null;
  
  // Status icon based on refund approval
  const getStatusIcon = () => {
    if (refundApproved === true) {
      return <ThumbsUp className="h-3.5 w-3.5 text-green-600" />;
    } else if (refundApproved === false) {
      return <ThumbsDown className="h-3.5 w-3.5 text-red-600" />;
    } else if (sentiment) {
      if (sentiment.includes('positive')) {
        return <ThumbsUp className="h-3.5 w-3.5 text-green-600" />;
      } else if (sentiment.includes('negative')) {
        return <ThumbsDown className="h-3.5 w-3.5 text-red-600" />;
      }
    }
    
    return <Minus className="h-3.5 w-3.5 text-gray-500" />;
  };
  
  // Status label
  const getStatusLabel = () => {
    if (refundApproved === true) {
      return "Refund Approved";
    } else if (refundApproved === false) {
      return "Refund Denied";
    } else if (sentiment) {
      return sentiment.charAt(0).toUpperCase() + sentiment.slice(1);
    }
    
    return "Unknown";
  };
  
  // Badge color
  const getStatusBadgeClass = () => {
    if (refundApproved === true) {
      return "bg-green-50 text-green-700 border-green-200";
    } else if (refundApproved === false) {
      return "bg-red-50 text-red-700 border-red-200";
    } else if (sentiment) {
      if (sentiment.includes('positive')) {
        return "bg-green-50 text-green-700 border-green-200";
      } else if (sentiment.includes('negative')) {
        return "bg-red-50 text-red-700 border-red-200";
      }
    }
    
    return "bg-gray-50 text-gray-700 border-gray-200";
  };
  
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge 
            variant="outline" 
            className={`ml-1 text-xs flex items-center gap-1 ${getStatusBadgeClass()}`}
          >
            {getStatusIcon()}
            <span>{getStatusLabel()}</span>
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          <p>Analysis of merchant's response</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default MessageStatus;
